export const THEME_STORAGE_KEY = 'oneteam-theme';
export const SYSTEM_THEME_QUERY = '(prefers-color-scheme: dark)';

export type ThemePreference = 'system' | 'light' | 'dark';
export type ResolvedTheme = 'light' | 'dark';
export type ApiColorScheme = 'automatic' | 'light' | 'dark';

export const DEFAULT_THEME: ThemePreference = 'system';
